import { createUseStyles } from 'react-jss';

export const progressStatStyles = createUseStyles({
  container: {

  },
});
